import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "registry-availability",
  class RegistryAvailability extends WYATTElement {
    constructor() {
      super();

      this.getAvailabilityForItem();
    }

    getAvailabilityForItem() {
      const endpoint = `${this.config.url}?variant=${this.config.variant_id}&view=availability`;

      fetch(endpoint)
        .then((response) => response.text())
        .then((html) => {
          this.injectMessage(html);
        });
    }

    async injectMessage(html) {
      const placeholder = this.querySelector("[data-message]");

      placeholder.outerHTML = html;
    }
  },
);
